export default class FormHeader {

    constructor($view) {

        this.$view = $view;
        this.$jonction = this.$view.find('#jonction');

        var data = this.$jonction[0].dataset.data;
        data = JSON.parse(data);
        var area = this.$jonction[0].dataset.area;
        area =JSON.parse(area);

        this.$information = this.$view.find('.information');
        this.$agenciesForSale = this.$view.find('.agenciesforsale');

        this.bind(data,area);
    }

    initMapael(data,area){

        var width = $(window).width();
        var enabledZoom;

            if (width >= 1024  ) {
                enabledZoom = true;
            }
            else {
                enabledZoom = false;
            }

        $(".mapcontainer").mapael({
            map: {
                name: "france_departments"
                // Enable zoom on the map
                ,
                zoom: {
                    enabled: enabledZoom
                }
                // Set default plots and areas style
                , defaultPlot: {
                    attrs: {
                        fill: "#004a9b"
                        , opacity: 0.6
                    }
                    , attrsHover: {
                        opacity: 1
                    }
                    , text: {
                        attrs: {
                            fill: "#505444"
                        }
                        , attrsHover: {
                            fill: "#000"
                        }
                    }
                }
                , defaultArea: {
                    attrs: {
                        fill: "#f4f4e8"
                        , stroke: "#ced8d0"
                    }
                    , attrsHover: {
                        fill: "#a4e100"
                    }
                    , text: {
                        attrs: {
                            fill: "#505444"
                        }
                        , attrsHover: {
                            fill: "#000"
                        }
                    }
                }
            },
            legend: {

                plot: {
                    title: "American cities",
                    slices: [{
                        label: "Value 1",
                        sliceValue: "Value 1",
                        type: "image",
                        url: "/frontoffice/img/icons/home.svg",
                        width: 14,
                        height : 14,
                        attrsHover: {
                        }
                    },]
                }
            },
            // Add some plots on the map
            plots: data,
            areas:area,
        });

    };


    bind(data, area) {

        // ajout des events sur les boutons (montre et cache les differentes section list ou map )
        $('.btn.btn-map').on('click', (e) => {
            e.preventDefault();
            $('.map-results').addClass('show');
            $('.search-results-listing').removeClass('show');

            //initialisation de la map au click sur le bouton
            this.initMapael(data,area);
            window.addEventListener('resize', (e)=> {
                this.initMapael(data,area);
            });

        });

        // reset button
        $('.btn-reset').on('click', function (e) {
            e.preventDefault();

            $('.ref-input').val('');
            $('.budgetMin-input').val('');
            $('.budgetMax-input').val('');

            $('.form-light').submit();
        });


    }


}